<template>
  <div class="col-xl-4 xl-100">
    <px-card title="Needs attention">
      <div class="card-body p-0">
        <ul class="list-group list-group-flush">
          <li
            class="list-group-item d-flex justify-content-between align-items-center px-3"
            v-for="item in items"
            :key="item.label"
          >
            <span class="d-flex align-items-center">
              <feather
                :type="item.icon"
                :style="'color:' + item.color + ';width:18px;height:18px'"
                class="mr-2"
              ></feather>
              {{ item.label }}
            </span>
            <span class="d-flex align-items-center">
              <b-badge :variant="item.count ? item.badge : 'light'" :class="item.count ? '' : 'text-muted'">
                {{ item.count }}
              </b-badge>
              <router-link :to="item.to" class="btn btn-sm btn-light ml-2">Open</router-link>
            </span>
          </li>
        </ul>
      </div>
    </px-card>
  </div>
</template>

<script>
export default {
  name: "needs-attention-panel",
  props: {
    stats: { type: Object, required: true }
  },
  computed: {
    items() {
      const t = this.stats.todo;
      return [
        {
          label: "Orders to prepare",
          count: t.toPrepare,
          icon: "clock",
          color: "#4680ff",
          badge: "primary",
          to: "/sales/order"
        },
        {
          label: "Orders in transit",
          count: t.inTransit,
          icon: "truck",
          color: "#ffb64d",
          badge: "warning",
          to: "/sales/order"
        },
        {
          label: "Abandoned carts",
          count: t.abandoned,
          icon: "shopping-cart",
          color: "#51bb25",
          badge: "success",
          to: "/sales/abondanedcart"
        },
        {
          label: "Products low in stock",
          count: t.lowStock,
          icon: "alert-triangle",
          color: "#f73164",
          badge: "danger",
          to: "/products/products-list"
        }
      ];
    }
  }
};
</script>

<style></style>
